import React from 'react';
import { Box, Typography, Stack, Tooltip } from '@mui/material';

const formatUSD = (v) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 0,
  }).format(v || 0);

const formatPct = (v) => `${(Number(v) || 0).toFixed(1)}%`;

export default function FormulaView({ data, onComponentClick }) {
  const isPercent = data.title?.includes('%') || data.title?.includes('Margin');
  const total = data.total_usd || 0;

  return (
    <Box>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        How this number was assembled
      </Typography>

      <Stack divider={<Box sx={{ borderBottom: '1px dashed', borderColor: 'divider' }} />}>
        {data.rows.map((c, i) => {
          const showTooltip = !c.drillable;
          const row = (
            <Stack
              direction="row"
              alignItems="center"
              spacing={2}
              sx={{
                py: 1.25,
                px: 1,
                cursor: c.drillable ? 'pointer' : 'default',
                '&:hover': c.drillable ? { backgroundColor: 'rgba(33, 150, 243, 0.05)' } : {},
                borderRadius: 1,
              }}
              onClick={() => c.drillable && onComponentClick && onComponentClick(c)}
            >
              <Box
                sx={{
                  width: 24,
                  fontWeight: 700,
                  color: c.sign === '-' ? 'error.main' : 'text.primary',
                  textAlign: 'center',
                }}
              >
                {i === 0 && c.sign !== '/' ? ' ' : c.sign}
              </Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography variant="body2" sx={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {c.label}
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 500 }}>
                {formatUSD(c.amount_usd)}
              </Typography>
            </Stack>
          );
          return showTooltip ? (
            <Tooltip key={i} title="Drill-down for this row coming in Phase 2" placement="left">
              {row}
            </Tooltip>
          ) : (
            <Tooltip key={i} title="Click to drill in" placement="left">
              {row}
            </Tooltip>
          );
        })}
      </Stack>

      {/* Total bar */}
      <Box
        sx={{
          mt: 2,
          p: 1.5,
          borderTop: '2px solid',
          borderColor: 'divider',
          bgcolor: 'rgba(0,0,0,0.04)',
          borderRadius: 1,
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {data.title?.split(' — ')[0] || 'Total'}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>
            {isPercent ? formatPct(total) : formatUSD(total)}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
}
